<template>
    <div class='tabChange' v-show="tabList.length >= 2 ">
        <div  v-for="(item,index) in tabList" 
            :key="index"
            :class="{active2:index == currentIndex}"
            @click="tabClick(index,item.id)"
            >
            {{item.style ? item.style : item.provinceName}}
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            tabList:{
                type:Array,
                default(){
                    return []
                }
            }
        },
        data(){
            return {
                currentIndex:0
            }
        },
        methods:{
            tabClick(index,id){
                this.currentIndex = index
                this.$emit('tabClick',index,id)
            }
        }
    }
</script>
<style scoped>
    .tabChange{
        width:100%;
        overflow: hidden;
        border:1px solid rgba(229, 229, 229, 1);
        color:rgba(128, 128, 128, 1);
        padding: 20px;
        padding-bottom:0;
    }
    .tabChange>div{
        cursor: pointer;
        float: left;
        margin-right:25px;
        margin-bottom: 20px ;
        border-bottom:1px solid #fff;
    }
    .tabChange>div.active2{
        color:var(--color-main);
        border-bottom:1px solid var(--color-main);
    }
@media screen and (max-width: 768px){
    .tabChange{
        width: 90%;
        margin:0 auto 0.5rem;
        font-size:0.28rem;
        padding: 0.3rem;
        padding-bottom:0;
    }
    .tabChange>div{
        margin-right:0.3rem;
        margin-bottom: 0.3rem ;
    }
}
</style>